import { render, staticRenderFns } from "./MyRSservices.vue?vue&type=template&id=38f7316a&scoped=true"
import script from "./MyRSservices.vue?vue&type=script&lang=js"
export * from "./MyRSservices.vue?vue&type=script&lang=js"
import style0 from "./MyRSservices.vue?vue&type=style&index=0&id=38f7316a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7316a",
  null
  
)

export default component.exports